import { Button, HStack, Text, Box, VStack } from "@chakra-ui/react";
import KellyansSide from "./KellyansSide";
import GarrettsSide from "./GarrettsSide";
import { useEffect, useState } from "react";

export default function WarGameDisplay({
  gameState,
  stepPhase,
  isSimulating,
  handleNewGameClick,
  handleActionButtonClick,
  handleSimulateGameClick,
}) {
  const [actionButtonText, setActionButtonText] = useState("Deal");

  useEffect(() => {
    if (
      stepPhase === "start" ||
      stepPhase === "resolve" ||
      stepPhase === "war_cleanup"
    ) {
      setActionButtonText("Deal");
    } else if (stepPhase === "flip_kellyan" || stepPhase === "war_flip_k") {
      setActionButtonText("Flip Kellyan");
    } else if (stepPhase === "flip_garrett" || stepPhase === "war_flip_g") {
      setActionButtonText("Flip Garrett");
    } else if (stepPhase === "war_reveal" || stepPhase === "war_reveal_all") {
      setActionButtonText("Show Cards");
    }
  }, [stepPhase]);

  const kellyanTotalCards =
    gameState.kellyanDeck.length +
    gameState.kellyanDownCards.length +
    gameState.kellyanEarnedCards.length;

  let sliderPercent = 100 * (kellyanTotalCards / 52);

  if (stepPhase === "game_over" && sliderPercent > 50) {
    sliderPercent = 100;
  } else if (stepPhase === "game_over" && sliderPercent > 50) {
    sliderPercent = 0;
  }

  const cardRed = "#E43D4D";
  const cardPink = "#E6A9EB";

  return (
    <VStack
      minW="350px"
      maxW="350px"
      minH="400px"
      maxH="400px"
      spacing="4px"
      position="relative"
    >
      {/* slider */}
      <HStack
        h="10px"
        w="100%"
        borderRadius="10px"
        position="absolute"
        top="45px"
        spacing="0px"
      >
        <Box
          w={`${sliderPercent}%`}
          h="9px"
          bg={cardPink}
          borderLeftRadius="10px"
          borderRightRadius={stepPhase === "game_over" ? "10px" : "0px"}
        />
        <Box
          w={`${100 - sliderPercent}%`}
          h="9px"
          bg={cardRed}
          borderLeftRadius={stepPhase === "game_over" ? "10px" : "0px"}
          borderRightRadius="10px"
        />
      </HStack>
      <HStack minW="350px" maxW="350px" align="center" spacing="0px">
        {/* Kellyan's side */}
        <KellyansSide gameState={gameState} />

        {/* Garrett's side */}
        <GarrettsSide gameState={gameState} stepPhase={stepPhase} />
      </HStack>

      <HStack>
        {stepPhase !== "game_over" && (
          <>
            {/* action button */}
            <Button w="100px" onClick={handleActionButtonClick}>
              {actionButtonText}
            </Button>

            {/* simulate game button */}
            <Button w="100px" onClick={handleSimulateGameClick}>
              {isSimulating ? "Stop" : "Simulate"}
            </Button>
          </>
        )}

        {stepPhase === "game_over" && (
          <Button w="100px" onClick={handleNewGameClick}>
            New Game
          </Button>
        )}
      </HStack>

      {/* message box */}
      <Box w="300px">
        <Text
          textAlign="center"
          fontSize="lg"
          opacity="80%"
          fontFamily="Lilita One, sans-serif"
          dangerouslySetInnerHTML={{ __html: gameState.message }}
        />
      </Box>
    </VStack>
  );
}
